import { Tag } from "../models/tag.model";

export class MemberSearch {
  id: string;
  memberId: number;
  firstName: string;
  lastName: string;
  dateOfBirth: Date;
  phoneNumber: string;
  primary: string;
  email: string;
  address: string;
  longitude: number;
  latitude: number; 
  frequency: number;
  enablePoints: boolean; 
  expandFunctions?: boolean;
  expanded?: boolean;
  confirmView?: boolean;
  editView?: boolean;
  toolsHelp?: boolean;  
  hasNotes: boolean;
  tags: Tag[];
}
